module.exports = __webpack_public_path__ + "img/dajiajuhome1.ec000ce8.png";